import { useEffect } from 'preact/hooks';

/**
 * Set document.title on mount, restore the previous title on unmount.
 * Used by admin pages so the browser tab reflects the current view.
 */
export function useDocumentTitle(title: string): void {
    useEffect(() => {
        const previous = document.title;
        document.title = title;
        return () => {
            document.title = previous;
        };
    }, [title]);
}
